import { createFileRoute } from '@tanstack/react-router'
import { templatesSearchSchema } from '../../../features/messaging/search'
import { requireLink } from '../../../features/settings/guards'
import { MessageTemplatesPage } from '../../../features/settings/message-templates-page'

export const Route = createFileRoute('/_app/settings/message-templates')({
  staticData: { crumb: 'settingsSection' },
  validateSearch: templatesSearchSchema,
  beforeLoad: ({ context }) => requireLink(context.session, 'messageTemplates'),
  component: MessageTemplatesPage,
})
